import { UmbracoBookingService } from './booking';
var ApiSettings = /** @class */ (function () {
    function ApiSettings() {
        this.baseUrl = '';
    }
    Object.defineProperty(ApiSettings.prototype, "BaseUrl", {
        set: function (url) {
            this.baseUrl = url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSettings.prototype, "ServiceUrl", {
        get: function () {
            return this.baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    return ApiSettings;
}());
export var apiSettings = new ApiSettings();
export var bookingService = new UmbracoBookingService();
